export class ListingTaskUtil {
  static type: boolean = false;
}
